/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner } from './update-user-usage-limit200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateUserUsageLimit200ResponseReissue } from './update-user-usage-limit200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateUserUsageLimit200ResponseUser } from './update-user-usage-limit200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateUserUsageLimit200ResponseUserAccountGroup } from './update-user-usage-limit200-response-user-account-group';

/**
 * 
 * @export
 * @interface UpdateUserUsageLimit200Response
 */
export interface UpdateUserUsageLimit200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserUsageLimit200Response
     */
    'availableCurrencies': Array<UpdateUserUsageLimit200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateUserUsageLimit200Response
     */
    'availableMerchantCategories': Array<UpdateUserUsageLimit200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateUserUsageLimit200ResponseUser}
     * @memberof UpdateUserUsageLimit200Response
     */
    'user': UpdateUserUsageLimit200ResponseUser;
    /**
     * 
     * @type {UpdateUserUsageLimit200ResponseUserAccountGroup}
     * @memberof UpdateUserUsageLimit200Response
     */
    'userAccountGroup'?: UpdateUserUsageLimit200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserUsageLimit200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserUsageLimit200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserUsageLimit200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {UpdateUserUsageLimit200ResponseReissue}
     * @memberof UpdateUserUsageLimit200Response
     */
    'reissue'?: UpdateUserUsageLimit200ResponseReissue | null;
}

export const UpdateUserUsageLimit200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateUserUsageLimit200ResponseAvailableCurrenciesEnum = typeof UpdateUserUsageLimit200ResponseAvailableCurrenciesEnum[keyof typeof UpdateUserUsageLimit200ResponseAvailableCurrenciesEnum];


